import { OTA_RELEASE_CHANNEL_ORDER } from './channelLabels';
import type { Build, ChannelPointer, OtaAppId, OtaReleaseChannelId } from './types';

/** Release channels whose pointer currently targets this build's version code. */
export function activeReleaseChannelsForBuild(
  build: Build,
  pointers: ChannelPointer[],
): OtaReleaseChannelId[] {
  const appId = build.appDir as OtaAppId;
  return OTA_RELEASE_CHANNEL_ORDER.filter((channel) =>
    pointers.some(
      (p) => p.app === appId && p.channel === channel && p.current === build.versionCode,
    ),
  );
}

export type BuildWithReleaseChannels = Build & {
  activeReleaseChannels: OtaReleaseChannelId[];
};

export function enrichBuildsWithReleaseChannels(
  builds: Build[],
  pointers: ChannelPointer[],
): BuildWithReleaseChannels[] {
  return builds.map((build) => ({
    ...build,
    activeReleaseChannels: activeReleaseChannelsForBuild(build, pointers),
  }));
}

/** Sibling APK for the other signing key at the same version (promoted together by default). */
export function siblingSigningBuild(
  build: Build,
  allBuilds: Build[],
): Build | undefined {
  const otherKey = build.signingKey === 'platform' ? 'standard' : 'platform';
  return allBuilds.find(
    (b) =>
      b.appDir === build.appDir &&
      b.versionCode === build.versionCode &&
      b.packageId === build.packageId &&
      b.signingKey === otherKey,
  );
}
